import {
  ActivityIndicator,
  View,
  type StyleProp,
  type ViewStyle,
} from "react-native";
import { semanticColors, typography } from "../theme/tokens";
import { MoonText } from "./MoonText";

type Props = {
  /** A short line under the spinner, such as "Loading your plan…". */
  caption?: string;
  /** `dark` on a dark surface: a light spinner and caption. */
  appearance?: "light" | "dark";
  style?: StyleProp<ViewStyle>;
  testID?: string;
};

/**
 * What a section or page shows while it loads, when the shape of what is
 * coming isn't known (states audit, #3873). Lists and cards use a skeleton
 * instead (`ListRowSkeleton`, `MoonSkeleton`); buttons keep their own
 * `loading`. A small spinner in the copper accent, with an optional caption.
 */
export function LoadingState({
  caption,
  appearance = "light",
  style,
  testID,
}: Props) {
  const dark = appearance === "dark";
  return (
    <View
      testID={testID}
      accessibilityRole="progressbar"
      accessibilityLabel={caption}
      style={[
        {
          alignItems: "center",
          justifyContent: "center",
          gap: 10,
          paddingVertical: 24,
        },
        style,
      ]}
    >
      <ActivityIndicator
        size="small"
        color={
          dark ? semanticColors.onDark.text.primary : semanticColors.text.link
        }
      />
      {caption ? (
        <MoonText
          style={{
            fontFamily: typography.families.sans,
            fontSize: 13,
            lineHeight: 18,
            textAlign: "center",
            color: dark
              ? semanticColors.onDark.text.tertiary
              : semanticColors.text.tertiary,
          }}
        >
          {caption}
        </MoonText>
      ) : null}
    </View>
  );
}
